module.exports = __webpack_public_path__ + "static/media/IOTX.e984c94e.png";